/* eslint-disable react/display-name */
import React from "react";
import {
  FormatBold,
  FormatItalic,
  FormatUnderlined,
  Code,
  Looks3,
  Looks4,
  FormatQuote,
  FormatListNumbered,
  FormatListBulleted,
  FormatAlignLeft,
  FormatAlignCenter,
  FormatAlignRight,
  FormatAlignJustify,
  InsertPhoto,
  Settings,
  Link,
  Mail,
} from "@emotion-icons/material";
import DividerIcon from "./icons/DividerIcon";
import VideoIcon from "./icons/VideoIcon";
import SimplecastIcon from "./icons/SimplecastIcon";
import CustomButtonIcon from "./icons/CustomButtonIcon";
import SocialMediasIcon from "./icons/SocialMediasIcon";

export const ICON_FORMAT_BOLD = "format_bold";
export const ICON_FORMAT_ITALIC = "format_italic";
export const ICON_FORMAT_UNDERLINE = "format_underlined";
export const ICON_FORMAT_CODE = "code";
export const ICON_HEADING_THREE = "looks_3";
export const ICON_HEADING_FOUR = "looks_4";
export const ICON_FORMAT_QUOTE = "format_quote";
export const ICON_FORMAT_LIST_NUMBERED = "format_list_numbered";
export const ICON_FORMAT_LIST_BULLETED = "format_list_bulleted";
export const ICON_FORMAT_ALIGN_LEFT = "format_align_left";
export const ICON_FORMAT_ALIGN_CENTER = "format_align_center";
export const ICON_FORMAT_ALIGN_RIGHT = "format_align_right";
export const ICON_FORMAT_ALIGN_JUSTIFY = "format_align_justify";
export const ICON_IMAGE = "image";
export const ICON_IMAGE_EDIT = "image_edit";
export const ICON_INSERT_DIVIDER = "divider";
export const ICON_YOUTUBE_VIDEO = "youtube_video";
export const ICON_SIMPLECAST = "simplecast";
export const ICON_SOCIAL_MEDIAS = "social_media";
export const ICON_CUSTOM_BUTTON = "custom_buton";
export const ICON_LINK = "link";
export const ICON_SUBSCRIBE_BUTTON = "subscribe_button";

const Icon = React.forwardRef(({ iconName, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    css={{
      borderRadius: "4px",
      padding: "4px 4px 6px 4px",
      "&:hover": {
        background: "#f3f3f3",
      },
    }}
  >
    {iconName === ICON_FORMAT_BOLD && <FormatBold size="24px" />}
    {iconName === ICON_FORMAT_ITALIC && <FormatItalic size="24px" />}
    {iconName === ICON_FORMAT_UNDERLINE && <FormatUnderlined size="24px" />}
    {iconName === ICON_FORMAT_CODE && <Code size="24px" />}
    {iconName === ICON_HEADING_THREE && <Looks3 size="24px" />}
    {iconName === ICON_HEADING_FOUR && <Looks4 size="24px" />}
    {iconName === ICON_FORMAT_QUOTE && <FormatQuote size="24px" />}
    {iconName === ICON_FORMAT_LIST_NUMBERED && <FormatListNumbered size="24px" />}
    {iconName === ICON_FORMAT_LIST_BULLETED && <FormatListBulleted size="24px" />}
    {iconName === ICON_FORMAT_ALIGN_LEFT && <FormatAlignLeft size="24px" />}
    {iconName === ICON_FORMAT_ALIGN_CENTER && <FormatAlignCenter size="24px" />}
    {iconName === ICON_FORMAT_ALIGN_RIGHT && <FormatAlignRight size="24px" />}
    {iconName === ICON_FORMAT_ALIGN_JUSTIFY && <FormatAlignJustify size="24px" />}
    {iconName === ICON_IMAGE && <InsertPhoto size="24px" />}
    {iconName === ICON_IMAGE_EDIT && <Settings size="24px" />}
    {iconName === ICON_INSERT_DIVIDER && <DividerIcon width="24px" />}
    {iconName === ICON_YOUTUBE_VIDEO && <VideoIcon height="24px" width="24px" />}
    {iconName === ICON_SIMPLECAST && <SimplecastIcon width="24px" height="24px" />}
    {iconName === ICON_SOCIAL_MEDIAS && <SocialMediasIcon width="24px" height="24px" />}
    {iconName === ICON_CUSTOM_BUTTON && <CustomButtonIcon height="24px" width="24px" />}
    {iconName === ICON_LINK && <Link height="24px" width="24px" />}
    {iconName === ICON_SUBSCRIBE_BUTTON && <Mail height="24px" width="24px" />}
  </div>
));

export default Icon;
